import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '../../../../../services/loading.service';
import { SnackService } from '../../../../../services/snack.service';
import { AbstractSignsPortalAssociationControllerRequestService } from '../abstract-signs-portal-association-controller-request.service';

@Injectable({
  providedIn: 'root',
})
export class SignPhoneNumberAdjustmentPortalOverviewControllerRequestService extends AbstractSignsPortalAssociationControllerRequestService {
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    super(
      http,
      snackService,
      loadingService,
      router,
      '/signphonenumberadjustments/global'
    );
  }
}
